/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import {
  AbstractControl,
  type FormArray,
  FormBuilder,
  type FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { CurrencyPipe, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, type TemplateRef, ViewChild, type OnInit } from '@angular/core';
import { catchError, concatMap, EMPTY, type Observable, of, tap, throwError } from 'rxjs';
import { NgxMaskDirective } from 'ngx-mask';

// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../shared/services/cms.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../shared/services/util.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Router } from '@angular/router';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { PaymentService } from '../../shared/services/payment.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../shared/services/storage.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { PaymentusService } from '../../shared/services/paymentus.service';

// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { MatDialog, MatDialogModule, MatDialogConfig } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';

import { PaymentMethod, type PaymentMethodResponse } from '../../shared/models/payment-method';
import { StorageEnum } from '../../shared/enums/storage.enum';
import { type AccountDetail } from '../../shared/models/account-detail';
import { PaymentAccountType } from '../../shared/enums/paymentaccounttype.enum';
import { format, toDate } from 'date-fns';
import { BankAccountFormComponent } from '../../shared/components/bank-account-form/bank-account-form.component';
import { type PaymentDialogResult } from '../../shared/models/payment-dialog-result';
import { DialogResultType } from '../../shared/enums/dialogresulttype.enum';
import { CreditCardFormComponent } from '../../shared/components/credit-card-form/credit-card-form.component';
import { environment } from '../../../environments/environment';
import { DigitalPaymentModalComponent } from '../../shared/components/digital-payment-modal/digital-payment-modal.component';
import { Capacitor } from '@capacitor/core';
import { BankAccountType } from '../../shared/enums/bankaccounttype.enum';
import { type UserProfile } from '../../shared/models/user-profile';
import { AutoPayCancel } from '../../shared/models/autopay-cancel';
import { AutoPay } from '../../shared/models/auto-pay';
import { SidePanelComponent } from '../../shared/components/side-panel/side-panel.component';
import { PaymentAccountTypeDisplayNamePipe } from '../../shared/pipes/payment-account-type-display-name.pipe';
import { Nav } from '../../shared/enums/nav.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { ErrorService } from '../../shared/services/error.service';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { PageHeader } from '../../shared/models/page-header.model';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { SeoService } from '../../shared/services/seo.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { NotificationsService } from '../../shared/services/notifications.service';
import { NotificationType } from '../../shared/enums/notificationtype.enum';
import { NotificationComponent } from '../../shared/components/notification/notification.component';

@Component({
  selector: 'app-wallet',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCardModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    NgxMaskDirective,
    MatButtonModule,
    MatDividerModule,
    SidePanelComponent,
    PaymentAccountTypeDisplayNamePipe,
    PageHeaderComponent,
    NotificationComponent,
  ],
  templateUrl: './wallet.component.html',
  styleUrl: './wallet.component.scss',
  providers: [PaymentAccountTypeDisplayNamePipe, CurrencyPipe],
})
export class WalletComponent implements OnInit {
  pageReady = false;
  pageLabels: any;
  formErrorMessage: string = '';
  isBrowser = false;
  paymethods: PaymentMethod[] = [];
  newPaymethodsList: PaymentMethod[] = [];
  accountDetail: AccountDetail;
  userProfile?: UserProfile;
  selectedPayMethod: PaymentMethod = new PaymentMethod();
  walletForm: FormGroup;
  paymentForms: FormArray;
  @ViewChild('editModal') editModal: TemplateRef<any> | undefined;
  paymentErrors: any[] = [];
  @ViewChild('deletePaymentDialogTemplate') deletePaymentDialogTemplate!: TemplateRef<any>;
  successMessage: string = '';
  deletePaymentAssociatedAutoPay: string = '';
  @ViewChild(MatAccordion) accordion!: MatAccordion;
  public showDialogContinueButton = true;
  public showDialogConfirmButton = false;
  sidePanelData: any = null;
  disableDigitalPayments: boolean = false;
  headerData = new PageHeader();
  pageName = 'Wallet';

  constructor(
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) readonly platformId: Object,
    private readonly cms: CmsService,
    public dialog: MatDialog,
    private readonly fb: FormBuilder,
    private readonly payment: PaymentService,
    private readonly paymentus: PaymentusService,
    private readonly router: Router,
    private readonly storage: StorageService,
    private readonly utils: UtilService,
    private readonly patDisplayNameP: PaymentAccountTypeDisplayNamePipe,
    private readonly error: ErrorService,
    private readonly currencyP: CurrencyPipe,
    private readonly seoS: SeoService,
    private readonly notifi: NotificationsService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.accountDetail = this.storage.getSession(StorageEnum.AccountDetail);
    this.userProfile = this.storage.getSession(StorageEnum.LoginResponse);
    this.paymentErrors = this.storage.getSession(StorageEnum.GlobalVars)?.paymentErrors;
    this.paymentForms = this.fb.array([]);
    this.walletForm = this.fb.group({
      PayForms: this.paymentForms,
      newPaymethod: this.fb.control<PaymentMethod | null>(null),
    });
    this.disableDigitalPayments = this.storage.getSession(StorageEnum.GlobalVars)?.disableDigitalPayments;
  }

  ngOnInit(): void {
    this.cms
      .getContent('oas-wallet', 'wallet')
      .pipe(
        concatMap((data) => {
          this.pageLabels = JSON.parse(JSON.stringify(data));
          this.headerData.Message = this.pageLabels.manageWalletHeadlineText;
          this.seoS.setSeoTags(data.seo);
          if (this.isBrowser) {
            this.setSidePanelData(data.sidePanelData);
            return this.getPreferredPayments();
          } else {
            return EMPTY;
          }
        }),
      )
      .subscribe((data: any) => {
        this.reloadPayMethods(data);

        this.pageReady = true;
        this.utils.hideSpinner();
      });
  }

  reloadPayMethods(data: any): void {
    this.storage.setSession(StorageEnum.PaymentMethods, data.PaymentMethods);
    if (!data.PaymentMethods) {
      data.PaymentMethods = [];
    }
    this.paymethods = this.payment.sortPaymentMethods(
      data.PaymentMethods,
      this.disableDigitalPayments,
      false,
      false,
      true,
    );

    this.paymentForms.clear();
    this.mapPayMethods();
    this.populateNewPaymentsDropDown();
  }

  setSidePanelData(panelArray: any[]): void {
    if (this.accountDetail.IsAutoPay) {
      this.sidePanelData = panelArray.find((panel) => {
        return panel.panelData.value.name === 'Autopay Change Panel';
      })?.panelData?.value?.data;
    } else if (!this.accountDetail.IsAutoPay && this.accountDetail.PastDueBalance === 0) {
      this.sidePanelData = panelArray.find((panel) => {
        return panel.panelData.value.name === 'Autopay Enroll Panel';
      })?.panelData?.value?.data;
    } else if (this.accountDetail.PastDueBalance! > 0 && this.accountDetail.IsEligibleForPayPlan) {
      this.sidePanelData = panelArray.find((panel) => {
        return panel.panelData.value.name === 'Pay Plan Enroll Panel';
      })?.panelData?.value?.data;
    } else if (this.accountDetail.PastDueBalance! > 0 && !this.accountDetail.IsEligibleForPayPlan) {
      this.sidePanelData = panelArray.find((panel) => {
        return panel.panelData.value.name === 'Account Balance Information Panel';
      })?.panelData?.value?.data;
      this.sidePanelData.accountBalance = this.currencyP.transform(this.accountDetail.CurrentBalance);
    }
  }

  getBtnAriaLabel(paymethod: PaymentMethod, type: string): string {
    if (type === 'remove') {
      return 'Remove ' + (paymethod.Nickname ?? this.patDisplayNameP.transform(paymethod.PaymentAccountType));
    } else if (type === 'update') {
      return (
        this.pageLabels.updateButtonText +
        (paymethod.Nickname ?? this.patDisplayNameP.transform(paymethod.PaymentAccountType))
      );
    }
    return paymethod.Nickname ?? this.patDisplayNameP.transform(paymethod.PaymentAccountType);
  }

  closeDigitalPanel(paymethod: PaymentMethod, panel: any): void {
    if (paymethod.BankCardDigital === 'DIGITAL') {
      panel.close();
    }
  }

  mapPayMethods(): void {
    this.paymethods.map((pm) => {
      let bankForm, cardForm, defaultForm;
      const expiredDate = this.formatExpDate(pm.ExpDate);
      switch (pm.BankCardDigital) {
        case 'BANK':
          bankForm = this.fb.group({
            Nickname: [pm.Nickname, [this.validateNickname.bind(this)]],
            RoutingNumber: [pm.BankRoutingNumber],
            AccountNumber: [pm.BankAccountNumber],
            SetDefault: [pm.IsDefault],
          });
          this.paymentForms.push(bankForm);
          return pm;
        case 'CARD':
          cardForm = this.fb.group({
            Nickname: [pm.Nickname, [this.validateNickname.bind(this)]],
            CardNumber: [pm.LastFour],
            ExpDate: [expiredDate, [Validators.required, this.validateExpirationDate.bind(this)]],
            SecurityCode: ['', [Validators.required, this.validateSecurityCode.bind(this)]],
            SetDefault: [pm.IsDefault],
            PayType: [pm.PaymentAccountType],
          });
          this.paymentForms.push(cardForm);
          return pm;
        case 'DIGITAL':
        default:
          defaultForm = this.fb.group({});
          this.paymentForms.push(defaultForm);
          return pm;
      }
    });
  }

  checkMask(type: PaymentAccountType | undefined): string {
    if (type === PaymentAccountType.AmericanExpress) {
      return '**** ****** *0000';
    } else if (
      type === PaymentAccountType.MasterCard ||
      type === PaymentAccountType.Visa ||
      type === PaymentAccountType.Discover
    ) {
      return '**** **** **** 0000';
    } else {
      return '**** **** **** 0000';
    }
  }

  formatExpDate(expDate: string | undefined): string {
    if (expDate) {
      return expDate.substring(0, 2) + '/' + expDate.substring(4);
    } else {
      return '';
    }
  }

  validateNickname(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    const nicknamePattern = /^[A-Za-z0-9 ]*$/;
    const nicknamePatternSpacesOnly = /^[ ]*$/;
    if (!nicknamePattern.test(value)) {
      return { invalidCharacters: true };
    }
    if (value) {
      if (value.length > 0 && nicknamePatternSpacesOnly.test(value)) {
        return { invalidCharacters: true };
      }
    }
    return null;
  }

  checkForDuplicateNickName(oldData: PaymentMethod, index: number): void {
    const paymentData = this.paymentForms.at(index).value;
    const nickNameValue = paymentData.Nickname;
    if (nickNameValue && paymentData.Nickname !== oldData.Nickname) {
      if (this.isDuplicateNickName(nickNameValue, index)) {
        this.paymentForms.at(index).get('Nickname')?.setErrors({ duplicateNickName: true });
      }
    }
  }

  isDuplicateNickName(nickNameValue: string, index: number): boolean {
    if (nickNameValue) {
      if (this.paymethods) {
        nickNameValue = nickNameValue.replace(/\s\s+/g, ' '); // double spaces and empty lines, etc.
        const recordFound = this.paymethods.find((p) => p.Nickname?.trim() === nickNameValue.trim());
        if (recordFound) {
          return true;
        }
      }
    }
    return false;
  }

  validateExpirationDate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) {
      return { required: true };
    }
    const [month, year] = value.split('/').map(Number);
    const currentYear = new Date().getFullYear() % 100; // Get last two digits of current year
    const currentYearMax = currentYear + 19;
    const currentMonth = new Date().getMonth() + 1; // Months are zero-indexed in JavaScript
    if (
      !month ||
      !year ||
      month < 1 ||
      month > 12 ||
      year < currentYear ||
      (year === currentYear && month < currentMonth) ||
      year > currentYearMax
    ) {
      return { invalidExpirationDate: true };
    }
    return null;
  }

  validateSecurityCode(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    const formGroup = control.parent as FormGroup;
    const regex = /^[0-9]+$/;
    if (!value) {
      return { required: true };
    }

    if (!regex.test(value)) {
      return { invalidSecurityCode: true };
    }

    if (formGroup) {
      let expectedPreferredLength: number;
      if (formGroup.value.PayType === PaymentAccountType.AmericanExpress) {
        expectedPreferredLength = 4;
      } else {
        expectedPreferredLength = 3;
      }
      if (value.length !== expectedPreferredLength) {
        return { invalidSecurityCode: true };
      }
    }

    return null;
  }

  getPreferredPayments(): Observable<PaymentMethodResponse> {
    return this.payment.getPreferredPayments(this.accountDetail).pipe(
      catchError((e) => {
        this.setErrorData(e.message);
        void this.router.navigateByUrl(Nav.ErrorPage);
        return EMPTY;
      }),
      tap((data) => {
        this.reloadPayMethods(data);
      }),
    );
  }

  setErrorData(errorCode: string): void {
    this.error.setErrorData(errorCode, this.pageLabels.walletErrorData[0].error);
  }

  setErrorDataForDelete(errorCode: string): void {
    this.error.setErrorData(errorCode, this.pageLabels.walletErrorData[1].error);
  }

  getPayMethodIcon(pm: PaymentMethod): string {
    let type = pm.PaymentAccountType;
    if (!type) {
      type = PaymentAccountType.Unknown;
    }
    switch (type) {
      case PaymentAccountType.AmericanExpress:
        return '<i class="fa-brands fa-cc-amex"></i>';
      case PaymentAccountType.ApplePay:
        return '<i class="fa-brands fa-apple-pay"></i>';
      case PaymentAccountType.Banking:
        if (pm.BankAccountType === BankAccountType.Savings) {
          return '<i class="fa-light fa-building-columns"></i>';
        } else {
          return '<i class="fa-solid fa-money-check"></i>';
        }
      case PaymentAccountType.Card:
        return '<i class="fa-regular fa-credit-card"></i>';
      case PaymentAccountType.Discover:
        return '<i class="fa-brands fa-cc-discover"></i>';
      case PaymentAccountType.GooglePay:
        return '<i class="fa-brands fa-google-pay"></i>';
      case PaymentAccountType.MasterCard:
        return '<i class="fa-brands fa-cc-mastercard"></i>';
      case PaymentAccountType.PayPal:
        return '<i class="fa-brands fa-paypal"></i>';
      case PaymentAccountType.Visa:
        return '<i class="fa-brands fa-cc-visa"></i>';
      case PaymentAccountType.Venmo:
        return '<i class="fa-kit fa-venmo-blk"></i>';
      default:
        return '<i class="fa-regular fa-money-bill-1"></i>';
    }
  }

  async goToAccountSummary(): Promise<void> {
    await this.router.navigateByUrl(Nav.AccountSummary);
  }

  updatePayMethod(oldData: PaymentMethod, index: number): void {
    this.formErrorMessage = '';
    this.successMessage = '';
    if (this.paymentForms.at(index)?.valid) {
      const paymentData = this.paymentForms.at(index).value;
      const paymethodInfo = new PaymentMethod();
      paymethodInfo.AccountNumber = this.accountDetail.AccountNumber;
      paymethodInfo.UserName = this.userProfile?.UserName;
      paymethodInfo.ActionCode = 'E';
      paymethodInfo.ReferenceId = oldData.ReferenceId;
      paymethodInfo.IsDefault = paymentData.SetDefault;
      if (paymentData.Nickname) {
        paymethodInfo.Nickname = paymentData.Nickname.trim();
      }
      if (oldData.BankCardDigital === 'BANK') {
        const currentYear = new Date().getFullYear() % 100; // Get last two digits of current year
        const currentMonth = new Date().getMonth() + 2; // Months are zero-indexed in JavaScript
        paymethodInfo.ExpDate = currentYear.toString().padStart(4, '20') + currentMonth.toString().padStart(2, '0');
      } else if (oldData.BankCardDigital === 'CARD') {
        const expirationDate = paymentData.ExpDate;
        const [month, year] = expirationDate.split('/').map(String);
        paymethodInfo.ExpDate = year.padStart(4, '20') + month;
      }
      this.utils.showSpinner();
      this.payment
        .updatePreferredPayment(paymethodInfo)
        .pipe(
          catchError((e) => {
            const errorMessage = this.pageLabels.walletUpdatePayMethodErrorMessage.replace(
              '{0}',
              oldData.BankCardDigital.toLowerCase(),
            );
            this.showFormErrorLabel(errorMessage);
            this.utils.hideSpinner();
            return EMPTY;
          }),
          concatMap((data) => {
            if (this.isBrowser) {
              return this.getPreferredPayments();
            } else {
              return EMPTY;
            }
          }),
        )
        .subscribe((data: any) => {
          this.successMessage = this.pageLabels.updatePaymentMethodSuccessMessage;
          this.reloadPayMethods(data);
          this.notifi.clearAllNotifications(this.pageName);
          this.notifi.addNotification(this.successMessage, NotificationType.Postnotification, this.pageName);
          this.utils.hideSpinner();
        });
    } else {
      this.paymentForms.at(index)?.markAllAsTouched();
      const errorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
      this.showFormErrorLabel(errorMessage);
    }
  }

  showFormErrorLabel(errorMessage: string): void {
    this.formErrorMessage = errorMessage;
    if (!this.utils.isNullOrUndefined(this.formErrorMessage) && this.formErrorMessage !== '' && this.formErrorMessage) {
      this.notifi.clearAllNotifications(this.pageName);
      this.notifi.addNotification(this.formErrorMessage, NotificationType.Error, this.pageName);
    }
  }

  deletePayMethod(paymethod: PaymentMethod): void {
    this.successMessage = '';
    this.deletePaymentAssociatedAutoPay = '';
    const title = this.pageLabels.deletePaymentMethodHeader;
    let content = '';
    const autoPayEnrolled = paymethod.IsAssociatedAutoPay;
    const today = format(new Date().toString(), 'MM/dd/yyyy');
    const billDueDate = format(toDate(this.accountDetail.CurrentBalanceDueDate!).toString(), 'MM/dd/yyyy');
    // reset flags
    this.showDialogContinueButton = true;
    this.showDialogConfirmButton = false;
    if (autoPayEnrolled) {
      const autoPayEnrollDate = format(toDate(this.accountDetail.AutoPay!.StartDate!).toString(), 'MM/dd/yyyy');
      // if auto pay enrollment date is today or current bill due date is today not eligible
      if (billDueDate === today) {
        content = this.pageLabels.deletePaymentMethodAutoPaySameDayBillDue;
        this.showDialogContinueButton = false;
        this.showDialogConfirmButton = true;
      } else if (autoPayEnrollDate === today) {
        content = this.pageLabels.deletePaymentMethodAutoPaySameDayEnrolled;
        this.showDialogContinueButton = false;
        this.showDialogConfirmButton = true;
      } else {
        content = this.pageLabels.deletePaymentMethodAssociatedAutoPay;
      }
    } else {
      content = this.pageLabels.deletePaymentMethodConfirmation;
    }
    const dialogConfig = new MatDialogConfig();
    // Optional configuration
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = 'first-heading';
    dialogConfig.data = {
      title,
      content,
    };
    // dialogConfig.maxWidth = 400;
    const dialogRef = this.dialog.open(this.deletePaymentDialogTemplate, dialogConfig);

    dialogRef
      .afterClosed()
      .pipe(
        concatMap((data) => {
          if (data === true) {
            if (paymethod.IsAssociatedAutoPay) {
              return this.cancelAutoPay();
            } else {
              return of({});
            }
          } else {
            return EMPTY;
          }
        }),
        concatMap((data) => {
          return this.deletePreferredPayment(paymethod);
        }),
      )
      .subscribe((data: any) => {
        this.utils.hideSpinner();
      });
  }

  cancelAutoPay(): Observable<any> {
    this.utils.showSpinner();
    const autoPayCancelRequest = new AutoPayCancel();
    autoPayCancelRequest.AccountNumber = this.accountDetail.AccountNumber;
    autoPayCancelRequest.RecurringScheduleId = this.accountDetail.AutoPay?.RecurringScheduleId;
    autoPayCancelRequest.CustomerClass = this.accountDetail.CustomerClass;

    if (this.accountDetail.AutoPay?.PaymentAccountType === PaymentAccountType.Banking) {
      return this.payment.cancelAutoPayBank(autoPayCancelRequest).pipe(
        catchError((e) => {
          const errorMessage = this.pageLabels.walletAutopayCancelErrorMessage;
          this.showFormErrorLabel(errorMessage);
          this.utils.hideSpinner();
          return EMPTY;
        }),
        tap(() => {
          this.accountDetail.IsAutoPay = false;
          this.accountDetail.AutoPay = new AutoPay();
          this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
        }),
      );
    } else {
      return this.payment.cancelAutoPayCard(autoPayCancelRequest).pipe(
        catchError((e) => {
          const errorMessage = this.pageLabels.walletAutopayCancelErrorMessage;
          this.showFormErrorLabel(errorMessage);
          this.utils.hideSpinner();
          return EMPTY;
        }),
        tap(() => {
          this.accountDetail.IsAutoPay = false;
          this.accountDetail.AutoPay = new AutoPay();
          this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
        }),
      );
    }
  }

  deletePreferredPayment(paymethod: PaymentMethod): Observable<any> {
    this.utils.showSpinner();
    paymethod.ActionCode = 'D';
    paymethod.AccountNumber = this.accountDetail.AccountNumber;
    paymethod.UserName = this.userProfile?.UserName;
    return this.payment.updatePreferredPayment(paymethod).pipe(
      catchError((e) => {
        if (paymethod.IsAssociatedAutoPay) {
          const errorMessage = this.pageLabels.walletPaymentMethodOnAutopayDeleteErrorMessage;
          this.showFormErrorLabel(errorMessage);
        } else {
          this.setErrorDataForDelete(e.message);
          void this.router.navigateByUrl(Nav.ErrorPage);
        }
        return EMPTY;
      }),
      concatMap((data: any) => {
        this.accordion.closeAll();
        const paymentIndex: number = this.paymethods.findIndex((pm: PaymentMethod) => {
          return pm.ReferenceId === paymethod.ReferenceId;
        });
        if (paymentIndex > -1) {
          this.paymethods.splice(paymentIndex, 1);
          this.paymentForms.controls.splice(paymentIndex, 1);
          this.successMessage = this.pageLabels.deletePaymentSuccessHeader;
          this.notifi.clearAllNotifications(this.pageName);
          this.notifi.addNotification(this.successMessage, NotificationType.Postnotification, this.pageName);
          if (paymethod.IsAssociatedAutoPay) {
            this.deletePaymentAssociatedAutoPay = this.pageLabels.deletePaymentAutoPaySuccessMessage;
          }
        }
        return this.getPreferredPayments();
      }),
    );
  }

  populateNewPaymentsDropDown(): void {
    this.newPaymethodsList = []; // clear the list first
    this.payment.getNewPayMethodsList(
      this.newPaymethodsList,
      'New Bank Method',
      'New Credit or Debit Card',
      this.storage.getSession(StorageEnum.PaymentMethods),
      this.disableDigitalPayments,
    );
  }

  paymethodChanged(): void {
    const selectedPaymethod: PaymentMethod = this.walletForm.get('newPaymethod')?.value;
    const selectedPaymethodType = this.payment.isCardBankDigital(selectedPaymethod.PaymentAccountType);
    if (selectedPaymethodType === 'BANK') {
      if (!selectedPaymethod.ReferenceId) {
        this.openBankAccountForm();
      }
    } else if (selectedPaymethodType === 'DIGITAL') {
      if (!selectedPaymethod.ReferenceId) {
        this.openDigitalPayment(selectedPaymethod.PaymentAccountType!);
      }
    } else if (selectedPaymethodType === 'CARD') {
      this.openCreditCardForm();
    } else if (selectedPaymethodType === 'CASH') {
      this.utils.consoleLog('cash money');
    } else {
      this.utils.consoleLog(`selectedPaymethodType: ${selectedPaymethodType}`);
    }
  }

  openBankAccountForm(): void {
    const dialogRef = this.dialog.open(BankAccountFormComponent, {
      ariaLabel: 'Bank Account',
      disableClose: true,
      autoFocus: 'first-heading',
      panelClass: 'gs-dialog',
      data: 'autopay',
    });

    dialogRef
      .afterClosed()
      .pipe(
        concatMap((result: PaymentDialogResult) => {
          if (result.Type?.toLowerCase() === 'add') {
            this.successMessage = this.pageLabels.addPaymentMethodSuccessMessage;
            this.notifi.clearAllNotifications(this.pageName);
            this.notifi.addNotification(this.successMessage, NotificationType.Postnotification, this.pageName);
          }
          this.utils.showSpinner();
          return this.getPreferredPayments();
        }),
      )
      .subscribe((data: any) => {
        this.reloadPayMethods(data);
        this.utils.hideSpinner();
      });
  }

  openCreditCardForm(): void {
    const dialogRef = this.dialog.open(CreditCardFormComponent, {
      ariaLabel: 'Credit Card',
      disableClose: true,
      autoFocus: 'first-heading',
      panelClass: 'gs-dialog',
      data: { payMethod: this.walletForm.get('newPaymethod')?.value, parentForm: 'wallet' },
    });

    dialogRef
      .afterClosed()
      .pipe(
        concatMap((result: PaymentDialogResult) => {
          this.utils.showSpinner();
          if (result.Type === DialogResultType.Error) {
            this.walletForm.patchValue({ paymethod: null });
            // TO DO this.showFormErrorLabel(result.ErrorMessage);
          }
          if (result.Type?.toLowerCase() === 'add') {
            this.successMessage = this.pageLabels.addPaymentMethodSuccessMessage;
            this.notifi.clearAllNotifications(this.pageName);
            this.notifi.addNotification(this.successMessage, NotificationType.Postnotification, this.pageName);
          }
          return this.getPreferredPayments();
        }),
      )
      .subscribe((data: any) => {
        this.reloadPayMethods(data);
        this.utils.hideSpinner();
      });
  }

  openDigitalPayment(paymentType: PaymentAccountType): void {
    const page = window.location.origin + Nav.Wallet;
    // Detect platform for mobile redirect flow
    const platform = Capacitor.isNativePlatform() ? (Capacitor.getPlatform() as 'ios' | 'android') : undefined;
    this.paymentus
      .getDigitalPaymentToken(this.accountDetail?.AccountNumber, paymentType, page, platform)
      .pipe(
        catchError((dataError: any) => {
          void this.router.navigateByUrl(Nav.ErrorPage);
          return throwError(() => new Error(dataError));
        }),
        concatMap((data) => {
          const url = environment.paymentusDigitalTokenUrl() + '?authToken=' + data;
          return this.createIframe(url, page, paymentType);
        }),
      )
      .subscribe((data: any) => {
        this.reloadPayMethods(data);
        this.utils.hideSpinner();
      });
  }

  createIframe(url: string, page: string, paymentAccountType: PaymentAccountType): Observable<any> {
    const dialogRef = this.dialog.open(DigitalPaymentModalComponent, {
      ariaLabel: paymentAccountType.toString(),
      disableClose: true,
      autoFocus: 'first-heading',
      panelClass: 'gs-dialog',
      data: {
        url,
        page,
        paymentAccountType,
        callbackUrlPattern: environment.digitalPaymentCallbackPath,
      },
      height: '500px',
      width: '500px',
    });

    return dialogRef.afterClosed().pipe(
      concatMap((result: PaymentDialogResult) => {
        this.utils.showSpinner();
        if (result.Type?.toLowerCase() === 'add') {
          this.successMessage = this.pageLabels.addPaymentMethodSuccessMessage;
          this.notifi.clearAllNotifications(this.pageName);
          this.notifi.addNotification(this.successMessage, NotificationType.Postnotification, this.pageName);
        }
        return this.getPreferredPayments();
      }),
    );
  }
}
